import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#5c4033] p-6">
      <div data-testid="payment-cancel" className="bg-[#fbf6ec] grain rounded-2xl p-8 max-w-sm w-full text-center paper-shadow-lift">
        <XCircle className="w-14 h-14 mx-auto text-[#a0703c]" />
        <h1 className="font-display font-black text-xl mt-4 text-[#2b2620]">Checkout cancelled</h1>
        <p className="text-sm text-[#6b6155] mt-2">No worries — your board is still here whenever you're ready.</p>
        <Button data-testid="cancel-to-profile" onClick={() => navigate("/profile")} className="w-full mt-6 rounded-full bg-[#ff3b30] hover:bg-[#e0271d] text-white font-display font-bold">Back to profile</Button>
      </div>
    </div>
  );
}
